// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__3_cOp","spinner-dot":"styles_spinner-dot__2lRGT","spinnerDot":"styles_spinner-dot__2lRGT","wave":"styles_wave__uIZew"};